import { type IXSLXImport } from '@principle-theorem/shared';
import type { Row } from 'exceljs';
import {
  type IAppointmentTagXSLX,
  APPOINTMENT_TAG_HEADERS,
} from './appointment-tags-to-xlsx';

export class XSLXToAppointmentTags implements IXSLXImport<IAppointmentTagXSLX> {
  headers = APPOINTMENT_TAG_HEADERS;

  translate(row: Row): IAppointmentTagXSLX {
    return {
      tag: row.getCell('tag').value?.toString() ?? '',
      mapTo: row
        .getCell('mapTo')
        .value?.toString() as IAppointmentTagXSLX['mapTo'],
    };
  }
}
